import React from 'react'
import Footer from '../components/Footer'

export default function sizeguide() {
  return (
    <div>
      <center>
          <h3 style={{backgroundColor:'black', 
                      color:'white',
                      padding:30,
                      }}
                      >Size Guide</h3>
          </center> 
          <div className='container'>
                      <h2>All the tables will come here</h2>
          </div>
          <br></br>
          <Footer />
    </div>
  )
}
